import { FlexDiv } from '../components'
import { useTheme, useMediaQuery, IconButton, Drawer } from '@mui/material'
import { Lease } from '../types/lease'
import { useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import { SideNav, SideNavWidth } from '../components/SideNav/SideNav'
import { LeasingMode } from '../types/leasingContext'

export interface Props {
    loggedIn: boolean
    children?: React.ReactNode
    selectedLease?: Lease | null
    mode?: LeasingMode
}

export const Layout = (props: Props) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const [mobileOpen, setMobileOpen] = useState(false)

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen)
    }

    // If not logged in, render children directly without navigation layout
    if (!props.loggedIn) {
        return <>{props.children}</>
    }

    return (
        <FlexDiv direction="column" style={{ flex: 1 }}>
            {!isMobile && (
                <SideNav selectedLease={props.selectedLease} mode={props.mode} />
            )}

            {/* Mobile Menu Button */}
            {isMobile && props.loggedIn && (
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{
                        position: 'fixed',
                        top: 12, // Adjusted to align with header
                        left: 16,
                        zIndex: 1200, // Increased to stay above header
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 1)',
                        },
                    }}
                >
                    <MenuIcon />
                </IconButton>
            )}

            {/* Mobile Drawer */}
            {isMobile && (
                <Drawer
                    variant="temporary"
                    anchor="left"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        '& .MuiDrawer-paper': { width: SideNavWidth },
                    }}
                >
                    <SideNav
                        selectedLease={props.selectedLease}
                        onMobileNavClick={handleDrawerToggle}
                        mode={props.mode}
                    />
                </Drawer>
            )}

            <FlexDiv
                direction="column"
                style={{
                    flex: 1,
                    marginLeft: isMobile ? 0 : SideNavWidth,
                    backgroundColor: '#1a1d21',
                    minHeight: '100vh',
                    width: '100%',
                    position: 'absolute',
                    top: 0,
                }}
            >
                {props.children}
            </FlexDiv>
        </FlexDiv>
    )
}
